export enum Inkomsttyp {
  UTDELNING = 'UTDELNING',
  RANTA = 'RANTA'
}
